<input type="hidden"
       [attr.name]="name || undefined"
       [attr.id]="id || undefined"
       [value]="queryProps"/>
<a
  class="button--link"
  (accessibleClick)="editQuery()"
  [accessibleClickStopEvent]="true"
  [textContent]="text.edit_query"></a>
